var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"61d28f00b55b9a382612eb693843af4bb23e5007"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["bridge128@bridge128-96"]={id:"61d28f00b55b9a382612eb693843af4bb23e5007"};
      